<div role="tablist" [attr.aria-label]="ariaLabel()" (keydown)="onKeydown($event)"
    class="flex min-w-0 gap-2 overflow-x-auto scrollbar-transparent">
    @for (tab of tabs(); track tab.id) {
    <button #tabButton type="button" role="tab" [id]="'scr-tab-' + tab.id"
        [attr.aria-selected]="tab.id === activeId()" [attr.aria-controls]="'scr-panel-' + tab.id"
        [attr.tabindex]="tab.id === activeId() ? 0 : -1" [attr.aria-label]="accessibleLabel(tab)"
        (click)="select(tab.id)"
        class="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 dark:focus-visible:outline-gray-200"
        [class]="tabClass(tab)">
        {{ tab.label }}
        @if (tab.count !== undefined) {
        <span aria-hidden="true" class="rounded-full px-2 py-0.5 text-xs font-bold" [class]="countClass(tab)">{{
            tab.count }}</span>
        }
    </button>
    }
</div>
